/**
 * 查看标签
 * @author hxliu
 * @date 2020-9-14
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
import { Row, Col, Spin } from 'antd'
let { WizModal, WizComponent, WizForm, WizCheckbox,WizButton } = component_tool;
const {WizContainer, WizReduxTemplate} = framework_tool;
let { $$, checkStrLength } = utils_tool;


class LookContentLabel extends WizContainer {

  componentName = 'LookContentLabel';

  constructor(props) {
    super(props);
    this.state = {
    }
  }
  /**
   * modal框的确定按钮触发
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = (data) => {
  };
  _onCancel(){
  }

  static defaultProps = {
    _ok: this._ok
  };
  render() {
    const { record } = this.props;
    const disabled = true

    const columns = [
      {
        title: "标签名称",
        name: "title",
        dataIndex: "title",
        formItem: {
          initialValue: record.title,
          disabled
        },
      },
      {
        title: "分类名称",
        name: "categoryName",
        dataIndex: "categoryName",
        formItem: {
          initialValue: record.categoryName,
          disabled
        },
      },
      {
        title: "顺序",
        name: "orderNo",
        dataIndex: "orderNo",
        formItem: {
            type: 'number',
          initialValue: record.orderNo,
          disabled
        },

      },
      {
        title: "标签热度值",
        name: "hotValue",
        dataIndex: "hotValue",
        formItem: {
            type: 'number',
          initialValue: record.hotValue,
          disabled
        },

      },
      {
        title: "标签说明",
        name: "intro",
        dataIndex: "intro",
        formItem: {
          type: 'textarea',
          initialValue: record.intro,
          disabled
        },
      },
    ]



    const formProps = {
      ref: 'form',
      columns,
      onSubmit: () => { },
      record,
      preview: false,
      footer: <div/>,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },

    };


    return (
<div>
      <WizForm {...formProps} />
      <Row>
            <Col span={22} />
            <Col span={2}>
              <WizButton type="primary" onClick={() => {
                this.props && this.props.changeModal(false)
              }}>确定</WizButton>
            </Col>
          </Row></div>

    );
  }
}

const mapStateToProps = (state, ownProps) => {
  };
  
  const options = {withRef: true};
  
  export default connect(mapStateToProps, null, null, options)(LookContentLabel);
